import { AppDispatch } from "@portal/redux/store";
import { setAgreementMonthlyAmount, setAgreementOneTimeDeposit } from "@portal/redux/reducers/savingProposalReducer";
import {
  setSavingsAgreementAdvisorName,
  setSavingsAgreementName,
  setSavingsAgreementPeriodDayNumber,
} from "@portal/redux/reducers/ui/createSavingsAgreement";
import {
  setMonthlyAmount,
  setNumOfMonthsStartupAmount,
  setOneTimeDeposit,
} from "@portal/redux/reducers/savingCalculationsReducer";

export const OnAdvisorChange = (name: string, dispatch: AppDispatch) => {
  dispatch(setSavingsAgreementAdvisorName(name));
};

export const OnMonthlyAmountChange = (amount: string, dispatch: AppDispatch) => {
  dispatch(setMonthlyAmount(Number(amount)));
  dispatch(setAgreementMonthlyAmount(Number(amount)));
};

export const OnSavingsNameChange = (name: string, dispatch: AppDispatch) => {
  dispatch(setSavingsAgreementName(name));
};

export const OnStartAmountChange = (amount: string, dispatch: AppDispatch) => {
  dispatch(setOneTimeDeposit(Number(amount)));
  dispatch(setAgreementOneTimeDeposit(Number(amount)));
};

export const OnNumMonthsChange = (id: number, dispatch: AppDispatch) => {
  const numMonths = GetNumMonths(id);
  dispatch(setNumOfMonthsStartupAmount(numMonths));
};

function GetNumMonths(index: number) {
  if (index === 0) return 1;
  if (index === 1) return 3;
  if (index === 2) return 6;
  if (index === 3) return 12;
  return 0;
}

export const OnPeriodDayChange = (id: number, dispatch: AppDispatch) => {
  const periodDayNumber = GetPeriodDayNumber(id);
  dispatch(setSavingsAgreementPeriodDayNumber(periodDayNumber));
};

function GetPeriodDayNumber(index: number) {
  if (index === 0) return 1;
  if (index === 1) return 10;
  if (index === 2) return 15;
  if (index === 3) return 25;
  return 0;
}
